// ----------------------------------------------------------------------

// Boolean operators the keyword search understands (item 23); they are not literal terms to highlight.
const OPERATORS = new Set(['AND', 'OR', 'NOT']);

/**
 * Split a raw keyword search string (as typed into the advanced-search keyword field, carried on the
 * `?q=` param) into the individual terms to highlight in resume text (spec item 18, JT1-1537). Quoted
 * phrases are kept whole; boolean operators and one-character noise are dropped. Returns an empty
 * array when there is nothing to highlight.
 */
export const parseHighlightTerms = (raw?: string | null): string[] => {
  if (!raw) return [];

  const tokens = raw.match(/"[^"]+"|\S+/g) ?? [];

  return tokens
    .map((token) => token.replace(/^"|"$/g, '').trim())
    .filter((term) => term.length >= 2 && !OPERATORS.has(term.toUpperCase()));
};
